import { Record } from 'immutable';
import { AnyAction } from 'redux';
import { createAction, handleActions } from 'redux-actions';
import { PURGE } from 'redux-persist';

const prefix = 'USER';

/**
 * @description ActionTypes
 * 액션타입
 */
export const ActionTypes = {
  INIT_STATE: `${prefix}/INIT_STATE`,
  SET_USER_DATA: `${prefix}/SET_USER_DATA`,
};

/**
 * @description ActionCtor
 * 액션 컨트롤러
 */
export const ActionCtorUser = {
  initState: createAction(ActionTypes.INIT_STATE),
  setUser: createAction(ActionTypes.SET_USER_DATA),
};

/**
 * @description Saga
 * 사이드 이펙트 관리
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function* UserSaga() {}

/**
 * @description State
 * 상태 정의
 */
export interface IUserInfo {
  userId: string;
  userIdx: number;
  groupIdx: number;
  result: string;
  groupName: string;
  userName: string;
  belong: string;
  role: string;
}

export interface IUser {
  userInfo: IUserInfo;
}

const UserRecord = Record<IUser>({
  userInfo: {
    userId: '',
    userIdx: 0,
    groupIdx: 0,
    result: '',
    groupName: '',
    userName: '',
    belong: '',
    role: '',
  },
});
export class UserState extends UserRecord {}

/**
 * @description Reducer
 * 상태변화가 일어나는곳
 */
const initialState = new UserState();
const UserReducer = handleActions<UserState, AnyAction>(
  {
    [ActionTypes.INIT_STATE]: () => {
      return new UserState();
    },

    [PURGE]: () => {
      return new UserState();
    },

    [ActionTypes.SET_USER_DATA]: (state, action) => {
      const userInfo: any | null = action.payload;
      // console.log('SET_USER_DATA ', userInfo);
      return {
        ...state,
        userInfo,
      };
      // return state.set('userInfo', userInfo);
    },
  },
  initialState
);

export default UserReducer;
